import { useApi } from '@healthblocks-io/core'
import { t } from '@lingui/macro'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { useHideNativeNavigation } from '@/layout/providers/LayoutProvider'
import { mixpanel } from '@/mixpanel'
import { NotFoundError } from '@/modules/shared/components/not-found-error/NotFoundError'
import { useTrackTaskDetailView } from '@/modules/task/hooks/useTrackTaskDetailView'
import { isIntramuros } from '@/utils/intramuros'
import { IntramurrosExpiredModal } from '../../timeline/pages/intramuros/IntramurosExpiredModal.page'
import { TaskDetailLayout } from '../components/detail-layout/TaskDetailLayout'
import { QuestionnaireDetail } from '../components/questionnaire-detail/QuestionnaireDetail'

import type { Task } from '@/modules/task/types/task.types'

export const IntramurosTaskDetailPage = () => {
  // State
  // ------------------------------------------------------------------------- /
  const [task, setTask] = useState<Task | null>(null)
  const [expired, setExpired] = useState<boolean>(false)
  const [hasError, setHasError] = useState<boolean>(false)
  // Hooks
  // ------------------------------------------------------------------------- /
  const { id, key } = useParams()

  useHideNativeNavigation()

  useEffect(() => {
    if (id) {
      fetchTaskByIntramurosKey()
    }
  }, [id])

  useTrackTaskDetailView({ task })

  const api = useApi()
  const fetchTaskByIntramurosKey = async () => {
    try {
      setHasError(false)
      const response = await axios.get<Task>(`${api}/task/${id}`, {
        headers: {
          Authorization: `Bearer ${key}`,
        },
      })
      setTask(response.data)

      return response.data
    } catch (error) {
      console.error(error)
      if ((error as any)?.response?.status === 403) {
        setExpired(true)
        mixpanel.track('task_error_intramuros_expired', {
          is_intramuros: isIntramuros,
        })
        return null
      }

      setHasError(true)
    }
  }

  // Render
  // ------------------------------------------------------------------------- /
  if (hasError) {
    return (
      <>
        <TaskDetailLayout>
          <TaskDetailLayout.ErrorHeader
            title={t({
              id: 'errors.not-found.title',
              comment: 'Something went wrong',
              message: 'Er gaat iets mis',
            })}
          />
          <TaskDetailLayout.Content>
            <NotFoundError onClick={fetchTaskByIntramurosKey} />
          </TaskDetailLayout.Content>
        </TaskDetailLayout>
        <IntramurrosExpiredModal isVisible={expired} />
      </>
    )
  }

  if (task?.type !== 'Questionnaire') {
    return null
  }

  return (
    <>
      <QuestionnaireDetail task={task} />
      <IntramurrosExpiredModal isVisible={expired} />
    </>
  )
}
